import React from 'react';
import PropTypes from 'prop-types';
import { FileUpload } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { ExamplePopupTrigger } from '../../../examplePopups/examplePopupTrigger';
import { UploadedFilePropTypes } from '../../../../propTypes/claimDetails';
import { useFileUpload } from './useFileUpload';
import { VALIDATION_ERROR_MESSAGE } from '../../../../constants/errorMessage';
import { FORM_KEYS } from '../../../../constants/formKeys';
import Loading from '../../../shared/Loading/Loading';
import { getGtmService } from '../../../../services/gtmService/GtmService';
import { DOCUMENT_TYPE } from '../../../../services/gtmService/consts';

export const UploadInvoices = ({ isReadOnly, claimInvoices, policyNumber }) => {
  const { files, loading, validationError, handleRemoveFile, handleFileChange, formContext } = useFileUpload({
    incomingFiles: claimInvoices,
    formKey: FORM_KEYS.INVOICES,
    requiredErrorMessage: VALIDATION_ERROR_MESSAGE.REQUIRED_INVOICE
  });

  const handleFileChangeWithGtm = (event) => {
    handleFileChange(event);

    const gtm = getGtmService();
    gtm.pushDocumentUpload(DOCUMENT_TYPE.INVOICE, policyNumber);
  };

  return (
    <fieldset>
      <h3>Upload your itemised invoice/s</h3>
      <p>A paid invoice that includes individual treatment items and costs adding up to the total amount paid.</p>
      <ExamplePopupTrigger exampleKey="invoice" />
      <p>Invoice/s to be uploaded in Step 3 only.</p>

      {loading ? (
        <Loading />
      ) : (
        <FileUpload
          name={FORM_KEYS.INVOICES}
          inputType="file"
          label="Select file/s"
          labelStyle="button"
          listStyle="reveal"
          customCssClass={formContext.formState.errors.invoices ? 'fileUploadCustomError' : ''}
          fieldFormContext={formContext}
          validation={{
            required: validationError(),
            maxFileCountLimit: VALIDATION_ERROR_MESSAGE.MAX_FILE_COUNT,
            unsupportedFileType: VALIDATION_ERROR_MESSAGE.UNSUPPORTED_FILE_TYPE
          }}
          readOnly={isReadOnly}
          placeholder="Itemised invoice/s"
          validFiles={{
            extensions: [
              'application/pdf',
              'image/apng',
              'image/gif',
              'image/jpeg',
              'image/pjpeg',
              'image/png',
              'image/tiff',
              'image/webp'
            ],
            fileTypes: 'documents',
            supportsLabel: 'pdfs, png, apng, jpeg, pjpeg, png, tiff, webp',
            maxFileSize: 10485760, // 10 MB
            maxFileCount: 8
          }}
          defaultSelectedFiles={files}
          customRemoveHandler={handleRemoveFile}
          customChangeHandler={handleFileChangeWithGtm}
        />
      )}
    </fieldset>
  );
};

UploadInvoices.propTypes = {
  isReadOnly: PropTypes.bool,
  claimInvoices: PropTypes.arrayOf(PropTypes.shape(UploadedFilePropTypes)),
  policyNumber: PropTypes.string
};
